export default __webpack_public_path__ + "static/media/banner_img.c1578b1e.png";